import { Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect } from "react";
import CustomButton from "../../../../components/common/button/CustomButton";
import FileUploader from "../../../../components/common/fileUploader/FileUploader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getAllTCDocumentListAction,
  getTCDocumentAction,
  setTCDocumentAction,
  setUpdateTCDocumentAction,
} from "../../../../store/reducers/documentSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

const OdtTemplate = () => {
  const dispatch = useDispatch();

  const {
    selectedDocument,
    isDocumentResponse,
    tcDocumentList,
    estimateODTTemplate,
    quoteODTTemplate,
    confirmationODTTemplate,
    invoiceODTTemplate,
  } = useSelector((state: any) => state.document);

  useEffect(() => {
    dispatch(getAllTCDocumentListAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, []);

  useEffect(() => {
    if (selectedDocument) {
      console.log("selectedDocument", selectedDocument);
      // Open the PDF in a new tab
      window.open(selectedDocument, "_blank");
      dispatch(setTCDocumentAction(null));
    }
  }, [selectedDocument]);

  useEffect(() => {
    if (isDocumentResponse) {
      console.log("isDocumentResponse", isDocumentResponse);
      dispatch(setUpdateTCDocumentAction(false));
    }
  }, [isDocumentResponse]);
  const OnViewHablde  = (name: string) => () =>{
    dispatch(getTCDocumentAction({docName: name}));
  };

  return (
    <>
      {/* Estimate ODT */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "16px",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Estimate ODT Template
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FileUploader
            onImageUpload={() => {}}
            width={60}
            height={60}
            accept=".odt"
            page="templates"
            showUploadButton={true}
            odtFileName="estimate"
            btnName={
              estimateODTTemplate?.doc_id &&
              estimateODTTemplate?.name?.trim() === "estimate"
                ? "Replace ODT Template"
                : "Upload ODT Template"
            }
          />
          {estimateODTTemplate?.doc_id &&
            estimateODTTemplate?.name?.trim() === "estimate" && (
              <CustomButton
                title={"Download ODT Template"}
                style={{ marginLeft: "6px" }}
                onClick={OnViewHablde('estimate')}
              />
            )}
        </div>
      </div>
      {/* Quote ODT */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "16px",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Quote ODT Template
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FileUploader
            onImageUpload={() => {}}
            width={60}
            height={60}
            accept=".odt"
            page="templates"
            showUploadButton={true}
            odtFileName="quote"
            btnName={
              quoteODTTemplate?.doc_id &&
              quoteODTTemplate?.name?.trim() === "quote"
                ? "Replace ODT Template"
                : "Upload ODT Template"
            }
          />
          {quoteODTTemplate?.doc_id &&
            quoteODTTemplate?.name?.trim() === "quote" && (
              <CustomButton
                title={"Download ODT Template"}
                style={{ marginLeft: "6px" }}
                onClick={OnViewHablde('quote')}
              />
            )}
        </div>
      </div>
      {/* Confirmation ODT */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "16px",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Confirmation ODT Template
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FileUploader
            onImageUpload={() => {}}
            width={60}
            height={60}
            accept=".odt"
            page="templates"
            showUploadButton={true}
            odtFileName="confirmation"
            btnName={
              confirmationODTTemplate?.doc_id &&
              confirmationODTTemplate?.name?.trim() === "confirmation"
                ? "Replace ODT Template"
                : "Upload ODT Template"
            }
          />
          {confirmationODTTemplate?.doc_id &&
            confirmationODTTemplate?.name?.trim() === "confirmation" && (
              <CustomButton
                title={"Download ODT Template"}
                style={{ marginLeft: "6px" }}
                onClick={OnViewHablde('confirmation')}
              />
            )}
        </div>
      </div>
      {/* Invoice ODT */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "16px",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Invoice ODT Template
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FileUploader
            onImageUpload={() => {}}
            width={60}
            height={60}
            accept=".odt"
            page="templates"
            showUploadButton={true}
            odtFileName="invoice"
            btnName={
              invoiceODTTemplate?.doc_id &&
              invoiceODTTemplate?.name?.trim() === "invoice"
                ? "Replace ODT Template"
                : "Upload ODT Template"
            }
          />
          {invoiceODTTemplate?.doc_id &&
            invoiceODTTemplate?.name?.trim() === "invoice" && (
              <CustomButton
                title={"Download ODT Template"}
                style={{ marginLeft: "6px" }}
                onClick={OnViewHablde('invoice')}
              />
            )}
        </div>
      </div>
    </>
  );
};
export default OdtTemplate;
